import Modal from './Modal';
import { calculateVat } from '../utils/tax';
import './CheckoutModal.css';

function formatKES(amount) {
  return `KES ${Number(amount || 0).toLocaleString()}`;
}

function DownloadIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3V15M12 15L7 10M12 15L17 10M5 19H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * E-commerce-style order summary shown before a Paystack payment is
 * launched. Used for both settling a due invoice (Billing) and paying for a
 * plan upgrade (My Account).
 */
export default function CheckoutModal({
  title = 'Checkout',
  items,
  currency = 'KES',
  onDownloadInvoice,
  onCheckout,
  processing,
  error,
  onClose,
}) {
  const subtotal = items.reduce((sum, item) => sum + item.amount, 0);
  const vat = calculateVat(subtotal);
  const total = subtotal + vat;

  return (
    <Modal title={title} onClose={onClose}>
      <div className="checkout-items">
        {items.map((item, i) => (
          <div key={i} className="checkout-item-row">
            <span className="checkout-item-label">{item.label}</span>
            <span className="checkout-item-amount">
              {currency} {Number(item.amount || 0).toLocaleString()}
            </span>
          </div>
        ))}
      </div>

      <div className="checkout-summary-rows">
        <div className="checkout-summary-row">
          <span>Subtotal</span>
          <span>{formatKES(subtotal)}</span>
        </div>
        <div className="checkout-summary-row">
          <span>VAT (16%)</span>
          <span>{formatKES(vat)}</span>
        </div>
      </div>

      <div className="checkout-total-row">
        <span>Total</span>
        <span>{formatKES(total)}</span>
      </div>

      {error && <div className="checkout-error">{error}</div>}

      <div className="checkout-actions">
        {onDownloadInvoice && (
          <button className="checkout-btn-secondary" onClick={onDownloadInvoice} disabled={processing}>
            <DownloadIcon />
            Download invoice
          </button>
        )}
        <button className="checkout-btn-primary" onClick={onCheckout} disabled={processing}>
          {processing ? 'Processing…' : 'Checkout'}
        </button>
      </div>
    </Modal>
  );
}
